export default __webpack_public_path__ + "static/media/fail-icon.6c3bcd75.svg";